import { render, staticRenderFns } from "./guia-do-app.vue?vue&type=template&id=7486ece2&scoped=true"
import script from "./guia-do-app.vue?vue&type=script&lang=js"
export * from "./guia-do-app.vue?vue&type=script&lang=js"
import style0 from "./guia-do-app.vue?vue&type=style&index=0&id=7486ece2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7486ece2",
  null
  
)

export default component.exports